export const tooltips = {
  refresh: "Reload the ban list from the server.",
  whitelistIp: "Open the whitelist dialog to allow traffic for an IP address.",
  banIp: "Open the ban dialog to add a temporary ban for an IP address.",
  logout: "End this console session.",
  theme: "Choose light, dark, or system appearance.",
  unban: "Remove this ban decision from the current list.",
  whitelistThisIp: "Open the whitelist dialog prefilled with this row’s IP.",
  siteHost: "Host name this dashboard is served from.",
  banThisIp: "Open the ban dialog prefilled with the IP you are looking up.",
  ipLookup: "Shows whether this IP appears in bans loaded from /api/decisions right now.",
} as const;
